import { render, staticRenderFns } from "./MobilePackageRenewal.vue?vue&type=template&id=a23f1360&scoped=true&"
import script from "./MobilePackageRenewal.vue?vue&type=script&lang=js&"
export * from "./MobilePackageRenewal.vue?vue&type=script&lang=js&"
import style0 from "./MobilePackageRenewal.vue?vue&type=style&index=0&id=a23f1360&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23f1360",
  null
  
)

export default component.exports